import { ref } from 'vue'

// Singleton loader state: one overlay is mounted at the app root (VueApp.vue) and driven from
// anywhere via useLoader() or the window.showLoader / window.hideLoader globals (which several
// components — SingleScheme, useReviewApi, Factory — already call).
const show = ref(false)
const title = ref('Please wait')
const text = ref('Do not refresh the page and wait while we are processing your information.')
const button = ref(false)
const url = ref<string | null>(null)
// Light backdrop (vs the default dark) — used when a skeleton behind the loader should stay visible.
const light = ref(false)

function showLoader(
  t = 'Please wait',
  msg = 'Do not refresh the page and wait while we are processing your information.',
  withButton = false,
  to: string | null = null,
  lightBackdrop = false
) {
  title.value = t
  text.value = msg
  button.value = withButton
  url.value = to
  light.value = lightBackdrop
  show.value = true
}

function hideLoader() {
  show.value = false
  button.value = false
  url.value = null
  light.value = false
}

export function useLoader() {
  return { show, title, text, button, url, light, showLoader, hideLoader }
}
